import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { IncidentsComponent } from "src/app/sections/incidents/incidents.component";
import { IncidentsModalComponent } from "src/app/sections/incidents/modal/incidents-modal.component";

import { HttpClient, HttpClientModule } from "@angular/common/http";
import { MaterialModule } from "../material/material.module";
import { TranslateModule, TranslateLoader } from "@ngx-translate/core";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { PlotlyModule } from "angular-plotly.js";
import { IncidentsRouterModule } from "./incidents-routes";

@NgModule({
  declarations: [IncidentsComponent, IncidentsModalComponent],
  imports: [
    CommonModule,
    // SharedModuleModule,
    MaterialModule,
    HttpClientModule,
    FormsModule,
    PlotlyModule,
    IncidentsRouterModule,
    ReactiveFormsModule,
    TranslateModule.forChild({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
    }),
  ],
})
export class IncidentsModule {}

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}
